export class LabBillHeaderModel {
    newLabBookingHeaderId: number;
    patientId?: number;
    doctorId?: number;
    employeeId?: number;
    locationId: number;
    overallTotalAmount: number;
    overallDiscount: number;
    overallNetAmount: number;
    overallDiscountPercentage?: number;
    payTypeId: number;
    createdBy: number;
    modifiedBy?: number;
    age?: number;
    requisitionNumber: string;
    type: string;
    paymentNumber: string;
    createdByName: string;
    modifiedByName: string;
    patientName: string;
    mobile: string;
    doctorName: string;
    patientThumbnailUrl: string;
    employeeName: string;
    payTypeName: string;
    locationName: string;
    umrNo: string;
    gender: string;
    createdDate: Date;
    modifiedDate?: Date;
    stastatusDate?: Date;
    totalItems: number;
    index?: number;
    newLabCancelBookingHeaderId?: number;
    totalReturnAmount?: number;
    active?: boolean;
    dateOfBirth: Date;
    encryptedId: string;
    isSelected: boolean;
    labs: Array<LabBillDetailModel>;
    status: string;
    testName: string;
    discountAmount?: number;
    totalAmount: number;
    netAmount: number;
    grandTotal?: number;
    isSalucroBill: boolean;
    isShow?: boolean;
    bookingType: string;
    typeOfPayment: string;
    paidAmount: number;
    paymentStatus: boolean;
    paymentType: string;
    constructor() {
        this.labs = new Array<LabBillDetailModel>();
    }
}

export class LabBillDetailModel {
    newLabBookingDetailId: number;
    newLabBookingHeaderId: number;
    labMainDetailId: number;
    chargeCategoryId: number;
    labBookingStatusId: number;
    discountPercentage?: number;
    discountAmount?: number;
    totalAmount: number;
    netAmount: number;
    status: string;
    testName: string;
    testCode: string;
    departmentName: string;
    chargeCategoryName: string;
    rowColor: string;
    collectedByName: string;
    collectionDate: Date;
    url: string;
    reportUrl: string;
    uploadedByName: string;
    uploadedDate?: Date;
    emergency: boolean;
    isExternalLab?: boolean;
    homeSample: boolean;
    technicianId?: number;
    technicianComment: string;
    technicianVerificationDate?: Date;
    submitting?: boolean;
}